import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import {
  AccordionDetails,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  Link,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { sectionNames } from 'src/components/QueryMenus/checklistQueriesData';
import { QueryMenus } from 'src/components/QueryMenus/QueryMenus';
import { SectionQueryIndication } from 'src/components/QueryMenus/sectionQueryIndication';
import { useQueryMenus } from 'src/components/QueryMenus/useQueryMenus';
import { ViewQuery } from 'src/components/QueryMenus/ViewQuery/ViewQuery';
import { sendRequest } from 'src/hooks/useFetch';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
// import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { clearMessage, setMessage } from 'src/store/Message';
import { setPath } from 'src/store/Navigation';
import { ISIVReportSiteAdequacy } from 'src/types/SIVReport';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import { useFieldTranslation } from '../../fields/useFieldTranslation';
import {
  ISiteAdequacyMandatory,
  ISIVReportMandatory,
  ISIVReportModifiedKeys,
  ISIVReportModifiedKeysOfKeys,
  MandatoryData
} from './useSivReport';
import { setIsSaveButtonDisable } from 'src/store/sivReport';

const NOTES_MAXLENGTH = 2000;
const pointer = { cursor: 'pointer' };

export interface ISiteAdequacy {
  siteAdequacyData: ISIVReportSiteAdequacy;
  updateSiteAdequacyData: (data: ISIVReportSiteAdequacy) => void;
  getSivReportData: (key: ISIVReportModifiedKeysOfKeys, add: boolean) => void;
  saveDisable: boolean;
  isUpdate: boolean;
  isChange: boolean;
  setIsChange: (step: ISIVReportModifiedKeys, key: ISIVReportModifiedKeysOfKeys, val: boolean) => void;
  updateSIVReportMandatoryData: (key: keyof ISIVReportMandatory, value: MandatoryData) => void;
  mandatory: ISiteAdequacyMandatory;
  sivReportSavedId: string;
  checkedInStartDate: any;
  isPublished: boolean;
  SignatureBreaking: () => void;
}
const SiteAdequacy: React.FunctionComponent<ISiteAdequacy> = ({
  getSivReportData,
  saveDisable,
  siteAdequacyData,
  updateSiteAdequacyData,
  isUpdate,
  isChange,
  setIsChange,
  mandatory,
  updateSIVReportMandatoryData,
  sivReportSavedId,
  checkedInStartDate,
  isPublished,
  SignatureBreaking
}) => {
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const dispatch = useDispatch();
  const user = useUser();
  const dispatchApp = useAppDispatch();
  const { sivcDataUpdateSuccessMsg, sivcMendatoryInfoErrorMsg, reportSiteAdequacy } = useFieldTranslation();
  const { userPreferedDateFormat, getServerDateOrInvalidDayJs } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const perDisable = checkPermission('update_siv_report');
  const isDisable = checkPermission('update_siv_report');
  const selectedRowData: any = useAppSelector(state => state.sivReport.selectedRowData);
  const { setTabVal, tabsData } = useTab();
  const [refreshKey, setRefreshKey] = useState(0);
  const [recentData, setRecentData] = useState({ data: {}, mandatoryValidation: {} });
  const saveButtonDisable: any = useAppSelector(state => state.sivReport.disableSaveButtonProps);
  const errorText = 'Required';

  const setValidationData = () => {
    const copyValidation = { ...mandatory };
    for (const key of Object.keys(copyValidation)) {
      if (
        siteAdequacyData[key as keyof ISIVReportSiteAdequacy] === 'N' &&
        !(
          siteAdequacyData[`${key}_comm` as keyof ISIVReportSiteAdequacy] &&
          siteAdequacyData[`${key}_comm` as keyof ISIVReportSiteAdequacy] !== null &&
          siteAdequacyData[`${key}_comm` as keyof ISIVReportSiteAdequacy] !== ''
        )
      ) {
        copyValidation[key as keyof ISiteAdequacyMandatory] = true;
      } else {
        copyValidation[key as keyof ISiteAdequacyMandatory] = false;
      }
    }
    updateSIVReportMandatoryData('siteAdequacy', copyValidation);
    return copyValidation;
  };
  const updateSiteAdequancyData = async () => {
    if (siteAdequacyData?.siv_report_fics_list == 'N') {
      const validate = setValidationData();
      if (Object.values(validate).indexOf(true) !== -1) {
        return dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
    }
    if (siteAdequacyData?.siv_report_study_supplies == 'N') {
      if (siteAdequacyData?.siv_report_study_supplies_comm == '') {
        return dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
      }
    }
    const reqObj: any = siteAdequacyData;
    if (siteAdequacyData?.equipments?.length <= 0) {
      delete reqObj.equipments;
    }

    if (
      siteAdequacyData.siv_report_fics_list !== null &&
      siteAdequacyData.siv_report_fics_list == 'Y' &&
      siteAdequacyData.siv_report_study_supplies !== null
    ) {
      if (siteAdequacyData.siv_report_doa == '') {
        reqObj.siv_report_doa = 'NA';
      }
      if (siteAdequacyData.siv_report_siv_training == '') {
        reqObj.siv_report_siv_training = 'NA';
      }
      if (siteAdequacyData.siv_report_contact_list == '') {
        reqObj.siv_report_contact_list = 'NA';
      }
    }

    const options = {
      site_id: selectedSite,
      study_id: studyId,
      data: {
        created_by: user.user,
        updated_by: user.user,
        monitoring_visit_id: selectedRowData?.id,
        siv_report: { step_one: { site_adequancy: reqObj } }
      },
      pathVariables: {
        country: selectedCountry,
        appName: process.env.REACT_APP_NAME
      }
    };
    try {
      if (isChange) {
        if (isUpdate) {
          if (
            (siteAdequacyData.siv_report_fics_list !== null &&
              siteAdequacyData.siv_report_fics_list == 'N' &&
              siteAdequacyData.siv_report_contact_list !== null &&
              siteAdequacyData.siv_report_doa !== null &&
              siteAdequacyData.siv_report_siv_training !== null &&
              siteAdequacyData.siv_report_contact_list !== '' &&
              siteAdequacyData.siv_report_doa !== '' &&
              siteAdequacyData.siv_report_siv_training !== '' &&
              siteAdequacyData.siv_report_contact_list !== 'NA' &&
              siteAdequacyData.siv_report_doa !== 'NA' &&
              siteAdequacyData.siv_report_siv_training !== 'NA' &&
              siteAdequacyData.siv_report_study_supplies !== null) ||
            (siteAdequacyData.siv_report_fics_list !== null &&
              siteAdequacyData.siv_report_fics_list == 'Y' &&
              siteAdequacyData.siv_report_study_supplies !== null)
          ) {
            await sendRequest('update_siv_report', options);
            if (isPublished) {
              SignatureBreaking();
            }
            getSivReportData('siteAdequacy', false);
            setConfirmExitValue(dispatch, false);
            setIsChange('Step1', 'siteAdequacy', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
        if (!isUpdate) {
          if (
            (siteAdequacyData.siv_report_fics_list !== null &&
              siteAdequacyData.siv_report_fics_list == 'N' &&
              siteAdequacyData.siv_report_contact_list !== null &&
              siteAdequacyData.siv_report_doa !== null &&
              siteAdequacyData.siv_report_siv_training !== null &&
              siteAdequacyData.siv_report_contact_list !== '' &&
              siteAdequacyData.siv_report_doa !== '' &&
              siteAdequacyData.siv_report_siv_training !== '' &&
              siteAdequacyData.siv_report_contact_list !== 'NA' &&
              siteAdequacyData.siv_report_doa !== 'NA' &&
              siteAdequacyData.siv_report_siv_training !== 'NA' &&
              siteAdequacyData.siv_report_study_supplies !== null) ||
            (siteAdequacyData.siv_report_fics_list !== null &&
              siteAdequacyData.siv_report_fics_list == 'Y' &&
              siteAdequacyData.siv_report_study_supplies !== null)
          ) {
            await sendRequest('create_siv_report', options);
            getSivReportData('siteAdequacy', true);
            setConfirmExitValue(dispatch, false);
            setIsChange('Step1', 'siteAdequacy', false);
            dispatchApp(setMessage({ msgDetails: sivcDataUpdateSuccessMsg, severity: 'success' }));
          } else {
            dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
          }
        }
      } else {
        dispatchApp(setMessage({ msgDetails: 'No data modified', severity: 'info' }));
      }
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, siteAdequacy: true }));
    } catch (e) {
      dispatchApp(setMessage({ msgDetails: sivcMendatoryInfoErrorMsg, severity: 'error' }));
    }
  };

  const handleSiteAdequancyData = (e: any) => {
    dispatchApp(clearMessage());
    const val = e.target.value;
    const formattedVal = typeof val === 'string' ? formatInput(val) : val;
    const value = formattedVal;
    if (e.target.type === 'radio' && value === 'Y') {
      updateSiteAdequacyData({ ...siteAdequacyData, [e.target.name]: value });
      updateSIVReportMandatoryData('siteAdequacy', { ...mandatory, [e.target.name]: false });
    } else if (e.target.type === 'radio') {
      updateSiteAdequacyData({ ...siteAdequacyData, [e.target.name]: value });
      updateSIVReportMandatoryData('siteAdequacy', { ...mandatory, [e.target.name]: false });
    }
    if (saveButtonDisable && e.target.type === 'radio') {
      dispatch(setIsSaveButtonDisable({ ...saveButtonDisable, siteAdequacy: false }));
    }
    setConfirmExitValue(dispatch, true);
  };

  const handleChange = (e: any) => {
    if (e.target.type !== 'radio') {
      const val = e.target.value;
      const formattedVal = typeof val === 'string' ? formatInput(val) : val;
      const value = formattedVal;
      setRecentData({
        data: {
          ...recentData.data,
          [e.target.name]: value
        },
        mandatoryValidation: { ...recentData.mandatoryValidation, [e.target.name]: false }
      });
    }
    if (saveButtonDisable) {
      dispatch(setIsSaveButtonDisable(false));
    }
  };
  useEffect(() => {
    if (Object.keys(recentData.data).length) {
      updateSiteAdequacyData({ ...siteAdequacyData, ...recentData.data });
      updateSIVReportMandatoryData('siteAdequacy', { ...mandatory, ...recentData.mandatoryValidation });
    }
  }, [recentData.data]);

  const handleChangeSelect = (e: any, id: any) => {
    const data = e.target.checked ? 'Y' : 'N';
    let updateEquipment;
    if (data === 'Y') {
      updateEquipment = siteAdequacyData.equipments.map((item: any) =>
        item.id == id ? { ...item, [e.target.name]: data } : { ...item }
      );
    } else {
      updateEquipment = siteAdequacyData.equipments.map((item: any) =>
        item.id == id ? { ...item, [e.target.name]: data, siv_report_equipment_date: null } : { ...item }
      );
    }
    updateSiteAdequacyData({ ...siteAdequacyData, equipments: updateEquipment });
    setConfirmExitValue(dispatch, true);
  };

  /**
   * Query menus code start
   */
  const {
    contextMenu,
    setContextMenu,
    queryKeys,
    setQueryKeys,
    checkListQueries,
    raisedQueries,
    totalFieldQueries,
    totalSectionQueries,
    fieldQueries,
    getSivReportQueries,
    raisedSectionQueries,
    report_id: reportId,
    setReport_id: setReportId,
    queryType,
    setQueryType,
    latestSecQueryRaisedBy
  } = useQueryMenus('SIV REPORT');

  useEffect(() => {
    setReportId(sivReportSavedId);
  }, [sivReportSavedId]);

  useEffect(() => {
    if (siteAdequacyData) {
      setRefreshKey(refreshKey + 1);
    }
  }, [Object.keys(siteAdequacyData)?.length]);

  const handleContextMenu = (event: React.MouseEvent, checklistItem: keyof ISIVReportSiteAdequacy) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null &&
        (checkPermission('view_queries_siv_report') ||
          checkPermission('view_audit_siv_report') ||
          checkPermission('raise_query_siv_report'))
        ? {
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4
          }
        : null
    );
    const sectionFieldNames: string[] = [];
    Object.keys(checkListQueries.site_adequancy).forEach((obj: any) => {
      sectionFieldNames.push(checkListQueries.site_adequancy[obj].report_field_name);
    });
    const newObj = {
      ...checkListQueries.site_adequancy[checklistItem],
      id: sivReportSavedId,
      section_key: 'site_adequancy',
      report_field_value: siteAdequacyData[checklistItem],
      section_field_names: sectionFieldNames,
      is_all_field_queries: true
    };
    setQueryKeys(newObj);
  };

  const [openViewQuery, setOpenViewQuery] = useState(false);
  const viewNotes = (checklistItem: keyof ISIVReportSiteAdequacy, isAllFieldQueries = false) => {
    let newObj: any = {};
    if (isAllFieldQueries) {
      const sectionFieldNames: string[] = [];
      Object.keys(checkListQueries.site_adequancy).forEach((obj: any) => {
        sectionFieldNames.push(checkListQueries.site_adequancy[obj].report_field_name);
      });
      newObj = {
        ...checkListQueries.site_adequancy[checklistItem],
        id: sivReportSavedId,
        section_key: 'site_adequancy',
        section_field_names: sectionFieldNames,
        is_all_field_queries: isAllFieldQueries
      };
    } else {
      newObj = {
        ...checkListQueries.site_adequancy[checklistItem],
        id: sivReportSavedId,
        section_key: 'site_adequancy',
        report_field_value: siteAdequacyData[checklistItem],
        is_all_field_queries: isAllFieldQueries
      };
    }

    setQueryKeys(newObj);
    setOpenViewQuery(true);
    setQueryType('ALL');
  };
  const perDisableQuery = checkPermission('view_queries_siv_report');
  /**
   * Query menus code end
   */

  // code Start for - CTMSKANBAN-1826 - SIV Report - Contactlist, DOA & SIV Training - shall Navigate to the respective pages
  const siteContactInfoPermission = checkPermission('view_site_contact_info');
  const viewStuduLogsPermission = checkPermission('view_study_logs');
  const doaPermission = checkPermission('view_site_doa');
  const sivTrainingPermission = checkPermission('view_site_siv_training');
  const navigateToTab = (path: string, tabTitle: string) => {
    dispatch(setPath(path));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === tabTitle);
    setTabVal(currentTabinfo[0].index);
  };

  const tabList = {
    siteContactInfo: 'siteContactInfo',
    studyLogs: 'studyLogs',
    path: {
      startup: 'startup',
      DOA: 'DOA',
      SIVTL: 'SIVTL'
    }
  };
  // End - CTMSKANBAN-1826 - SIV Report - Contactlist, DOA & SIV Training - shall Navigate to the respective pages

  return (
    <>
      <AccordionDetails className="sq-checklist-tab">
        <Grid container className="checklist-radio-actions">
          {raisedSectionQueries.includes(sectionNames.site_adequacy) &&
            sectionNames.site_adequacy in latestSecQueryRaisedBy &&
            SectionQueryIndication(
              latestSecQueryRaisedBy,
              sectionNames.site_adequacy,
              viewNotes,
              'siv_report_fics_list'
            )}
          <Grid md={12}>
            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_fics_list');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9}>
                {reportSiteAdequacy.label1}. <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      value={siteAdequacyData.siv_report_fics_list}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="siv_report_fics_list"
                      onChange={handleSiteAdequancyData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_fics_list')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${
                      raisedQueries.includes('siv_report_fics_list') ||
                      raisedSectionQueries.includes(sectionNames.site_adequacy)
                        ? ' danger-link'
                        : ''
                    }`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_fics_list_comm"
                    key={`siv_report_fics_list_comm-${refreshKey}`}
                    defaultValue={siteAdequacyData.siv_report_fics_list_comm || ''}
                    onBlur={handleSiteAdequancyData}
                    error={mandatory['siv_report_fics_list']}
                    helperText={mandatory['siv_report_fics_list'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <ul style={{ marginTop: 0 }}>
              <li>
                <Grid
                  container
                  onContextMenu={e => {
                    handleContextMenu(e, 'siv_report_contact_list');
                  }}
                  style={{ cursor: 'context-menu' }}
                >
                  <Grid md={9} className="alignCenterRow">
                    {siteContactInfoPermission ? (
                      <Link
                        onClick={() => navigateToTab(tabList.path.startup, tabList.siteContactInfo)}
                        style={pointer}
                        underline="always"
                      >
                        <Typography>
                          {reportSiteAdequacy.label2} <span style={{ color: 'red' }}>*</span>
                        </Typography>
                      </Link>
                    ) : (
                      <Typography>
                        {reportSiteAdequacy.label2} <span style={{ color: 'red' }}>*</span>
                      </Typography>
                    )}
                  </Grid>
                  <Grid md={3}>
                    <Stack direction="row" spacing={1} justifyContent="space-between">
                      <FormControl>
                        <RadioGroup
                          value={siteAdequacyData.siv_report_contact_list}
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="siv_report_contact_list"
                          onChange={handleSiteAdequancyData}
                        >
                          <FormControlLabel
                            disabled={
                              !isDisable ||
                              siteAdequacyData.siv_report_fics_list === 'Y' ||
                              saveDisable ||
                              !checkedInStartDate
                            }
                            value="Y"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            disabled={
                              !isDisable ||
                              siteAdequacyData.siv_report_fics_list === 'Y' ||
                              saveDisable ||
                              !checkedInStartDate
                            }
                            value="N"
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                      </FormControl>
                      <Button
                        onClick={() => viewNotes('siv_report_contact_list')}
                        disabled={!perDisableQuery}
                        title="Query"
                        className={`grey-btn${raisedQueries.includes('siv_report_contact_list') ? ' danger-link' : ''}`}
                      >
                        <LiveHelpOutlinedIcon />
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid md={12} className="comment-section">
                    <FormControl fullWidth margin="normal" className="siv-comment-input">
                      <TextField
                        name="siv_report_contact_list_comm"
                        key={`siv_report_contact_list_comm-${refreshKey}`}
                        defaultValue={siteAdequacyData.siv_report_contact_list_comm || ''}
                        onBlur={handleSiteAdequancyData}
                        error={mandatory['siv_report_contact_list']}
                        helperText={mandatory['siv_report_contact_list'] ? errorText : ''}
                        label="Notes"
                        variant="outlined"
                        inputProps={{ maxLength: NOTES_MAXLENGTH }}
                        disabled={
                          siteAdequacyData.siv_report_contact_list !== 'N' ||
                          !isDisable ||
                          siteAdequacyData.siv_report_fics_list === 'Y' ||
                          saveDisable
                        }
                        onChange={handleChange}
                        multiline
                        minRows={1}
                        maxRows={10}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
              <li>
                <Grid
                  container
                  onContextMenu={e => {
                    handleContextMenu(e, 'siv_report_doa');
                  }}
                  style={{ cursor: 'context-menu' }}
                >
                  <Grid md={9} className="alignCenterRow">
                    {viewStuduLogsPermission && doaPermission ? (
                      <Link
                        onClick={() => navigateToTab(tabList.path.DOA, tabList.studyLogs)}
                        style={pointer}
                        underline="always"
                      >
                        <Typography>
                          {reportSiteAdequacy.label3} <span style={{ color: 'red' }}>*</span>
                          <Tooltip
                            title="Were all staff CV’s reviewed to confirm that the training and experience of each staff member was adequate for the duties delegated on the Delegation of Authority log?"
                            placement="right"
                          >
                            <Button className="grey-btn">
                              <InfoOutlinedIcon />
                            </Button>
                          </Tooltip>
                        </Typography>
                      </Link>
                    ) : (
                      <Typography>
                        {reportSiteAdequacy.label3} <span style={{ color: 'red' }}>*</span>{' '}
                        <Tooltip
                          title="Were all staff CV’s reviewed to confirm that the training and experience of each staff member was adequate for the duties delegated on the Delegation of Authority log?"
                          placement="right"
                        >
                          <Button className="grey-btn">
                            <InfoOutlinedIcon />
                          </Button>
                        </Tooltip>
                      </Typography>
                    )}
                  </Grid>
                  <Grid md={3}>
                    <Stack direction="row" spacing={1} justifyContent="space-between">
                      <FormControl>
                        <RadioGroup
                          value={siteAdequacyData.siv_report_doa}
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="siv_report_doa"
                          onChange={handleSiteAdequancyData}
                        >
                          <FormControlLabel
                            disabled={
                              !isDisable ||
                              siteAdequacyData.siv_report_fics_list === 'Y' ||
                              saveDisable ||
                              !checkedInStartDate
                            }
                            value="Y"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            disabled={
                              !isDisable ||
                              siteAdequacyData.siv_report_fics_list === 'Y' ||
                              saveDisable ||
                              !checkedInStartDate
                            }
                            value="N"
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                      </FormControl>
                      <Button
                        onClick={() => viewNotes('siv_report_doa')}
                        disabled={!perDisableQuery}
                        title="Query"
                        className={`grey-btn${raisedQueries.includes('siv_report_doa') ? ' danger-link' : ''}`}
                      >
                        <LiveHelpOutlinedIcon />
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid md={12} className="comment-section">
                    <FormControl fullWidth margin="normal" className="siv-comment-input">
                      <TextField
                        name="siv_report_doa_comm"
                        key={`siv_report_doa_comm-${refreshKey}`}
                        defaultValue={siteAdequacyData.siv_report_doa_comm || ''}
                        onBlur={handleSiteAdequancyData}
                        error={mandatory['siv_report_doa']}
                        helperText={mandatory['siv_report_doa'] ? errorText : ''}
                        label="Notes"
                        variant="outlined"
                        inputProps={{ maxLength: NOTES_MAXLENGTH }}
                        disabled={
                          siteAdequacyData.siv_report_doa !== 'N' ||
                          !isDisable ||
                          siteAdequacyData.siv_report_fics_list === 'Y' ||
                          saveDisable
                        }
                        onChange={handleChange}
                        multiline
                        minRows={1}
                        maxRows={10}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
              <li>
                <Grid
                  container
                  onContextMenu={e => {
                    handleContextMenu(e, 'siv_report_siv_training');
                  }}
                  style={{ cursor: 'context-menu' }}
                >
                  <Grid md={9} className="alignCenterRow">
                    {viewStuduLogsPermission && sivTrainingPermission ? (
                      <Link
                        onClick={() => navigateToTab(tabList.path.SIVTL, tabList.studyLogs)}
                        style={pointer}
                        underline="always"
                      >
                        {' '}
                        <Typography>
                          {reportSiteAdequacy.label4}
                          <span style={{ color: 'red' }}>*</span>
                        </Typography>
                      </Link>
                    ) : (
                      <Typography>
                        {reportSiteAdequacy.label4}
                        <span style={{ color: 'red' }}>*</span>
                      </Typography>
                    )}
                  </Grid>
                  <Grid md={3}>
                    <Stack direction="row" spacing={1} justifyContent="space-between">
                      <FormControl>
                        <RadioGroup
                          value={siteAdequacyData.siv_report_siv_training}
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="siv_report_siv_training"
                          onChange={handleSiteAdequancyData}
                        >
                          <FormControlLabel
                            disabled={
                              !isDisable ||
                              siteAdequacyData.siv_report_fics_list === 'Y' ||
                              saveDisable ||
                              !checkedInStartDate
                            }
                            value="Y"
                            control={<Radio />}
                            label="Yes"
                          />
                          <FormControlLabel
                            disabled={
                              !isDisable ||
                              siteAdequacyData.siv_report_fics_list === 'Y' ||
                              saveDisable ||
                              !checkedInStartDate
                            }
                            value="N"
                            control={<Radio />}
                            label="No"
                          />
                        </RadioGroup>
                      </FormControl>
                      <Button
                        onClick={() => viewNotes('siv_report_siv_training')}
                        disabled={!perDisableQuery}
                        title="Query"
                        className={`grey-btn${raisedQueries.includes('siv_report_siv_training') ? ' danger-link' : ''}`}
                      >
                        <LiveHelpOutlinedIcon />
                      </Button>
                    </Stack>
                  </Grid>
                  <Grid md={12} className="comment-section">
                    <FormControl fullWidth margin="normal" className="siv-comment-input">
                      <TextField
                        name="siv_report_siv_training_comm"
                        key={`siv_report_siv_training_comm-${refreshKey}`}
                        defaultValue={siteAdequacyData.siv_report_siv_training_comm || ''}
                        onBlur={handleSiteAdequancyData}
                        error={mandatory['siv_report_siv_training']}
                        helperText={mandatory['siv_report_siv_training'] ? errorText : ''}
                        label="Notes"
                        variant="outlined"
                        inputProps={{ maxLength: NOTES_MAXLENGTH }}
                        disabled={
                          siteAdequacyData.siv_report_siv_training !== 'N' ||
                          !isDisable ||
                          siteAdequacyData.siv_report_fics_list === 'Y' ||
                          saveDisable
                        }
                        onChange={handleChange}
                        multiline
                        minRows={1}
                        maxRows={10}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </li>
            </ul>
            <Grid
              container
              onContextMenu={e => {
                handleContextMenu(e, 'siv_report_study_supplies');
              }}
              style={{ cursor: 'context-menu' }}
            >
              <Grid md={9} className="alignCenterRow">
                {reportSiteAdequacy.label5} <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid md={3}>
                <Stack direction="row" spacing={1} justifyContent="space-between">
                  <FormControl>
                    <RadioGroup
                      value={siteAdequacyData.siv_report_study_supplies}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="siv_report_study_supplies"
                      onChange={handleSiteAdequancyData}
                    >
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="Y"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        disabled={!isDisable || saveDisable || !checkedInStartDate}
                        value="N"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <Button
                    onClick={() => viewNotes('siv_report_study_supplies')}
                    disabled={!perDisableQuery}
                    title="Query"
                    className={`grey-btn${raisedQueries.includes('siv_report_study_supplies') ? ' danger-link' : ''}`}
                  >
                    <LiveHelpOutlinedIcon />
                  </Button>
                </Stack>
              </Grid>
              <Grid md={12} className="comment-section">
                <FormControl fullWidth margin="normal" className="siv-comment-input">
                  <TextField
                    name="siv_report_study_supplies_comm"
                    key={`siv_report_study_supplies_comm-${refreshKey}`}
                    defaultValue={siteAdequacyData.siv_report_study_supplies_comm || ''}
                    onBlur={handleSiteAdequancyData}
                    error={mandatory['siv_report_study_supplies']}
                    helperText={mandatory['siv_report_study_supplies'] ? errorText : ''}
                    label="Notes"
                    variant="outlined"
                    inputProps={{ maxLength: NOTES_MAXLENGTH }}
                    disabled={!isDisable || saveDisable || !checkedInStartDate}
                    onChange={handleChange}
                    multiline
                    minRows={1}
                    maxRows={10}
                  />
                </FormControl>
              </Grid>
            </Grid>
            {siteAdequacyData?.equipments?.length > 0 &&
              siteAdequacyData.equipments.map((item: any) => {
                return (
                  <Grid container key={item.id}>
                    <>
                      <Grid md={2.5} sx={{ pt: 2 }}>
                        <Stack direction="row" spacing={1}>
                          <Chip
                            key={item.id}
                            label={item.siv_report_equipment}
                            size="small"
                            color="primary"
                            variant="outlined"
                          />
                        </Stack>
                      </Grid>
                      <Grid md={1} sx={{ pt: 1, pl: 1 }}>
                        <FormControlLabel
                          control={<Checkbox disabled={!perDisable || saveDisable || !checkedInStartDate} />}
                          label=""
                          name="siv_report_equipment_yn"
                          key={item.id}
                          value="item.siv_report_equipment_yn"
                          onChange={e => handleChangeSelect(e, item.id)}
                          checked={item.siv_report_equipment_yn === 'Y' ? true : false}
                        />
                      </Grid>
                      <Grid md={2} className="custom-date">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Stack spacing={3}>
                            <DatePicker
                              label="Date Checked"
                              inputFormat={userPreferedDateFormat.toUpperCase()}
                              key={item.id}
                              // value={preferedFormatForDatePicker(item.siv_report_equipment_date)}
                              value={item.siv_report_equipment_date}
                              disabled={
                                item.siv_report_equipment_yn === 'N' ||
                                !perDisable ||
                                saveDisable ||
                                !checkedInStartDate
                              }
                              onChange={newValue => {
                                if (newValue) {
                                  const selectedDate = siteAdequacyData.equipments.map((equ: any) =>
                                    equ.id == item.id
                                      ? {
                                          ...equ,
                                          siv_report_equipment_date: getServerDateOrInvalidDayJs(newValue)
                                        }
                                      : { ...equ }
                                  );
                                  updateSiteAdequacyData({ ...siteAdequacyData, equipments: selectedDate });
                                } else {
                                  const selectedDate = siteAdequacyData.equipments.map((equ: any) =>
                                    equ.id == item.id ? { ...equ, siv_report_equipment_date: newValue } : { ...equ }
                                  );
                                  updateSiteAdequacyData({ ...siteAdequacyData, equipments: selectedDate });
                                }
                              }}
                              renderInput={params => <TextField {...params} error={item.error} />}
                            />
                          </Stack>
                        </LocalizationProvider>
                      </Grid>{' '}
                    </>
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      </AccordionDetails>
      <Grid container className="fixed-buttons-block">
        {checkPermission('update_siv_report') ? (
          <Grid md={12} display="flex" justifyContent="flex-end">
            <Stack spacing={2} direction="row">
              {isDisable ? (
                <Button
                  onClick={updateSiteAdequancyData}
                  variant="text"
                  disabled={saveButtonDisable?.siteAdequacy || !checkedInStartDate}
                >
                  SAVE
                </Button>
              ) : (
                ''
              )}
            </Stack>
          </Grid>
        ) : (
          ''
        )}
        <QueryMenus
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          contextMenu={contextMenu}
          setContextMenu={setContextMenu}
          queryKeys={queryKeys}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          report_id={reportId}
          checkListQueries={checkListQueries}
          queryType={queryType}
          setQueryType={setQueryType}
          isSQSivQueries
        />
        <ViewQuery
          totalFieldQueries={totalFieldQueries}
          totalSectionQueries={totalSectionQueries}
          open={openViewQuery}
          setOpen={setOpenViewQuery}
          queryKeys={queryKeys}
          queryType={queryType}
          fieldQueries={fieldQueries}
          getSivReportQueries={getSivReportQueries}
          setQueryType={setQueryType}
          report_id={reportId}
          isSQSivQueries
        />
      </Grid>
    </>
  );
};

export default SiteAdequacy;
